export const calculateDTIRatio = (annualIncome, debts) => {
    const monthlyIncome = annualIncome / 12;
    const dtiRatio = (debts / monthlyIncome) * 100;
    return dtiRatio.toFixed(2);
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  
  export const convertCamelCaseToTitleCase = (camelCaseString) => {
    const words = camelCaseString.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(word => capitalizeFirstLetter(word)).join(' ');
  };

  export const getLocalizedFieldLabel = (questionKey, lang) => {
    const translations = {
      English: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        purchasePrice: "Purchase Price",
        propertyValue: "Property Value",
        downPayment: "Down Payment",
        annualIncome: "Annual Income",
        debts: "Debts",
        cashOutAmount: "Cash Out Amount",
        firstLeinAmount: "First Lien Amount",
        secondLeinAmount: "Second Lien Amount",
        city: "City",
        address: "Address",
        zipCode: "Zip Code",
        county: "County",
        state: "State",
        creditScore: "Credit Score",
      },
      Spanish: {
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Correo electrónico",
        phoneNumber: "Número de teléfono",
        purchasePrice: "Precio de compra",
        propertyValue: "Valor de la propiedad",
        downPayment: "Pago inicial",
        annualIncome: "Ingreso anual",
        debts: "Deudas",
        cashOutAmount: "Monto a retirar",
        firstLeinAmount: "Monto del primer gravamen",
        secondLeinAmount: "Monto del segundo gravamen",
        city: "Ciudad",
        address: "Dirección",
        zipCode: "Código postal",
        county: "Condado",
        state: "Estado",
        creditScore: "Puntaje de crédito",
      },
    };

    const safeLang = lang === "Spanish" ? "Spanish" : "English";
    return (
      translations[safeLang]?.[questionKey] ||
      translations.English?.[questionKey] ||
      convertCamelCaseToTitleCase(questionKey)
    );
  };

  export const getAccessToken = () => {
    return window.localStorage.getItem("cx_access_token");
  };

  export const getRateCards = () => {
    return window.localStorage.getItem('ratesData');
  }

  export const getUserEmail = () => {
    return window.localStorage.getItem("user_email");
  };

  export const getTokenExpiryTime = () => {
    return window.localStorage.getItem("token_expiry");
  };

  export const getHeaders = () => {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
      "x-useremail": getUserEmail(),
      "x-expires-in": getTokenExpiryTime(),
    };
  }

  